import cx from 'classnames';
import Image from 'common/components/Image';
import { StyledFlex } from 'common/styles/common.styles';
import { OutboundLink } from 'gatsby-plugin-google-gtag';
import React, { PropsWithChildren } from 'react';
import { StyledAPButton } from './linkButton.style';
import useSelectedChain from 'hooks/useSelectedChain';
import { ChainId } from 'constants/constants';
import { useAccount } from 'wagmi';
import Tooltip from '../Tooltip/Tooltip';

type Props = {
  disabled?: boolean;
  id?: string;
  className?: string;
};

export const ArchiveProtocolButton: React.FC<Props & PropsWithChildren> = (
  props
) => {
  const { chainId } = useSelectedChain();
  const { address: userAccount } = useAccount();
  const deploymentId = chainId === ChainId.Mainnet ? 'ichi' 
    : (chainId === ChainId.Polygon ? 'ichi' : '');
  if (deploymentId === '') return null;

  const btnClassName = props.className?.replace('icon-new-window-white', '');
  const btnHeight = props.className?.includes(' h-') ? '' : 'h-10';
  return (
    <div className='w-10 tablet:w-12'>
      <Tooltip
        message='View your portfolio on Archive Protocol.'
        position='left'
        bubbleSize={{ width: '200px', }}
      >
        <StyledAPButton>
          <OutboundLink target="_blank" 
            href={`https://explore.archiveprotocol.com/${deploymentId}/${userAccount}`}>
            <button
              className={cx(
                `bg-black p-2 border-white border-2 ${btnHeight}`,
                props.disabled &&
                  `primary-button-disabled-bg-color ${btnClassName} ${btnHeight}`
              )}
              type="button"
              id={props.id}
            >
              <StyledFlex justifyContent="center">
                <Image src='https://ichi-images.s3.amazonaws.com/logos/Archive-Protocol-logo-white.png' height='20px' alt='Archive Protocol' />
              </StyledFlex>
            </button>
          </OutboundLink>
        </StyledAPButton>
      </Tooltip>
    </div>
  );
};
